import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <header className={`modern-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="header-logo">
            {/* <span className="logo-text">Profit Technologies</span> */}
            <img src={require('../assets/images/logo-01.png')} alt="Profit Technologies" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">HOME</Link>
              </li>

              <li className="nav-item">
                <Link to="/about" className="nav-link">ABOUT</Link>
              </li>

              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  SERVICES
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div className="dropdown-menu">
                  <Link to="/services/website-development" className="dropdown-link">Web Development</Link>
                  <Link to="/services/app-development" className="dropdown-link">App Development</Link>
                  <Link to="/services/digital-marketing" className="dropdown-link">Digital Marketing</Link>
                  <Link to="/services/startup-consulting" className="dropdown-link">Startup Consulting</Link>
                  <Link to="/services/software-development" className="dropdown-link">Software Development</Link>
                  <Link to="/services/it-consulting" className="dropdown-link">IT Consulting</Link>
                </div>
              </li>

              {/* <li className="nav-item">
                <Link to="/portfolio" className="nav-link">PORTFOLIO</Link>
              </li> */}
              <li className="nav-item">
                <Link to="/clients" className="nav-link">CLIENTS</Link>
              </li>

              <li className="nav-item">
                <Link to="/contact" className="nav-link nav-link-cta">GET IN TOUCH</Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-menu">
            <li className="mobile-nav-item">
              <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>HOME</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/about" className="mobile-nav-link" onClick={toggleMobileMenu}>ABOUT</Link>
            </li>

            <li className="mobile-nav-item">
              <button
                className="mobile-nav-link"
                onClick={() => toggleDropdown('services')}
              >
                SERVICES
                <svg className={`dropdown-icon ${openDropdown === 'services' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'services' ? 'open' : ''}`}>
                <Link to="/services/website-development" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Website Development</Link>
                <Link to="/services/app-development" className="mobile-dropdown-link" onClick={toggleMobileMenu}>App Development</Link>
                <Link to="/services/digital-marketing" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Digital Marketing</Link>
                <Link to="/services/startup-consulting" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Startup Consulting</Link>
                <Link to="/services/software-development" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Software Development</Link>
                <Link to="/services/it-consulting" className="mobile-dropdown-link" onClick={toggleMobileMenu}>IT Consulting</Link>
              </div>
            </li>

            {/* <li className="mobile-nav-item">
              <Link to="/portfolio" className="mobile-nav-link" onClick={toggleMobileMenu}>PORTFOLIO</Link>
            </li> */}
            <li className="mobile-nav-item">
              <Link to="/clients" className="mobile-nav-link" onClick={toggleMobileMenu}>CLIENTS</Link>
            </li>

            {/* <li className="mobile-nav-item">
              <button
                className="mobile-nav-link"
                onClick={() => toggleDropdown('resources')}
              >
                RESOURCES
                <svg className={`dropdown-icon ${openDropdown === 'resources' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'resources' ? 'open' : ''}`}>
                <Link to="/resources/blog" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Blog</Link>
                <Link to="/resources/case-studies" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Case Studies</Link>
                <Link to="/resources/whitepapers" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Whitepapers</Link>
              </div>
            </li> */}

            <li className="mobile-nav-item">
              <Link to="/contact" className="mobile-nav-link mobile-nav-link-cta" onClick={toggleMobileMenu}>Get in Touch</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
